<template>

    <section class="hero">
        <div class="hero-body">
            <div v-for="item in unfinished">
                <p><button v-on:click="doItem(item)">Go</button> {{ item.name }}</p>
            </div>            
        </div>
    </section>
</template>

<script>
import db from "../db";
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';
import config from '../config';
import ItemMixins from '../mixins/ItemMixins';

export default {
    
    mixins: [ItemMixins],

    firestore: {
        items: db.collection('items')
    },

    data() {
        return {
            items: [],
            
        }
    },

    computed: {
        unfinished() {
            return this.items.filter(item => {
                return item.id.indexOf(' ') !== -1;
            });
        }
    },

    methods: {
        async doItem(item) {

            //delete item

            item.pictures = await Promise.all(item.pictures.map(async pic => {
                let data = await this.delete(pic);
                console.log('data', data);
                return '';
            }));

            await db.collection('items').doc(this.slug(item.name)).delete().catch(error => {
                console.log('item delete error', error);
                return;
                //swal
            });

            // item.pictures = await Promise.all(item.pictures.map(async pic => {
            //     let id = await this.upload(pic.src);
            //     console.log('result id', id);
            //     return id;
            // }));

            // db.collection('items').doc(this.slug(item.name)).set(item);
        },

        delete(public_id) {
            let url = `https://api.cloudinary.com/v1_1/${config.cloudinaryName}/image/destroy`;
            return fetch(url, {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
                body: JSON.stringify({ public_id })
            })
            .then(response => response.json())
            .then(data => {
                console.log(data);
                return data;
            });
        },

        upload(url, i) {
            let cloudurl = `https://api.cloudinary.com/v1_1/${config.cloudinaryName}/image/upload`;
            return fetch(cloudurl, {
                method: 'POST',
                body: JSON.stringify({
                    file: url,
                    upload_preset: 'rmonch13'
                }),
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                }
            })
            .then(response => response.json())
            .then(data => {
                let id = data.public_id;
                console.log('id', id);
                return id;
            });
        }
    }
};


</script>